import { useEffect, useState } from "react";
import moment from "moment";

import { Button, Modal, Divider, Table, Typography, Skeleton } from "antd";
import { PrinterOutlined } from "@ant-design/icons";

import { ReferenceCode } from "utils/enums";
import { formatDate } from "utils/helpers";

import ClaimHistoryDetailModalProps from './Proptypes';

import "./index.scss";

const { Title } = Typography;

const ClaimHistoryDetailModal = (props: ClaimHistoryDetailModalProps) => {
  const [claimMaster, setClaimMaster] = useState([] as any);
  const [claimDetails, setClaimDetails] = useState([] as any);
  const [claimDiags, setClaimDiags] = useState([] as any);

  const paymentDetailColumns = [
    {
      title: "REFERENCE",
      key: "RmiDiagRefNo",
      dataIndex: "RmiDiagRefNo",
      render: (_: number, record: any) => ReferenceCode[record.RmiDiagRefNo]
    },
    {
      title: "DIAG CODE",
      key: "RmiDiag",
      dataIndex: "RmiDiag",
    },
    {
      title: "DESCRIPTION",
      key: "RmiDiagDesc",
      dataIndex: "RmiDiagDesc",
    },
  ];

  const amountBilledColumns = [
    {
      title: <Typography.Text ellipsis={true} style={{width: '50px'}}>FROM<br />TO</Typography.Text>,
      key: "RmiToDateSvc",
      dataIndex: "RmiToDateSvc",
      render: (_: number, record: any) => record.RmiFromDateSvc + ' ' + record.RmiToDateSvc
    },
    {
      title: "CPT",
      key: "RmiProcCode",
      dataIndex: "RmiProcCode"
    },
    {
      title: "MODIFIER",
      key: "RmiModif",
      dataIndex: "RmiModif",
      render: (_: number, record: any) => {
        let modifiers = '';
        if (record.RmiModif) modifiers += `${ReferenceCode[record.RmiModif]}, `;
        if (record.RmiModif2) modifiers += `${ReferenceCode[record.RmiModif2]}, `;
        if (record.RmiModif3) modifiers += `${ReferenceCode[record.RmiModif3]}, `;
        if (record.RmiModif4) modifiers += `${ReferenceCode[record.RmiModif4]}`;
        return modifiers;
      }
    },
    {
      title: "DIAG REF",
      key: "RmiDiagRefNum",
      dataIndex: "RmiDiagRefNum",
      render: (_: number, record: any) => ReferenceCode[record.RmiDiagRefNum]
    },
    {
      title: "QTY",
      key: "RmiQty",
      dataIndex: "RmiQty",
    },
    {
      title: "BILLED",
      key: "RmiBilled",
      dataIndex: "RmiBilled",
      render: (_: number, record: any) => `$${parseInt(record.RmiBilled).toFixed(2)}`
    },
    {
      title: "CO-PAY Co-Insure",
      key: "RmiCopay",
      dataIndex: "RmiCopay",
      render: (_: number, record: any) => `$${parseInt(record.RmiCopay).toFixed(2)}`
    },
    {
      title: "DED",
      key: "RmiDeductible",
      dataIndex: "RmiDeductible",
      render: (_: number, record: any) => `$${parseInt(record.RmiDeductible).toFixed(2)}`
    },
    {
      title: "ADJ",
      key: "RmiAdjCode",
      dataIndex: "RmiAdjCode",
    },
    {
      title: "NET PAID",
      key: "RmiNet",
      dataIndex: "RmiNet",
      render: (_: number, record: any) => `$${parseInt(record.RmiNet).toFixed(2)}`
    },
  ];

  useEffect(() => {
    if (props.claimHistoryDetailModal.claimMaster) setClaimMaster(props.claimHistoryDetailModal.claimMaster);
    if (props.claimHistoryDetailModal.claimDetails) setClaimDetails(props.claimHistoryDetailModal.claimDetails);
    if (props.claimHistoryDetailModal.claimDiags) setClaimDiags(props.claimHistoryDetailModal.claimDiags);
  }, [props.claimHistoryDetailModal])

  const handleCancel = () => {
    props.isModalVisibleHandler();
  };

  /**
   * hide - all sections of eligibility page
   * show - print logo and the modal window
   */
  const print = () => {
    $(".print-logo").removeClass('exclude-print').addClass("include-print");
    window.print();
  }

  return (
    <Modal
      className="print-claim-history-detail-modal"
      visible={props.isModalVisible}
      okText="Submit"
      width={1000}
      cancelText="Cancel"
      onCancel={handleCancel}
      footer={false}
    >
      <Title className="text-center" level={3}>Claim Detail</Title>

      <Divider className="claim-history-detail-form-modal-divider" />

      {props.isFetchingEZ ? (
        <>
          <Skeleton
            active
            paragraph={{ rows: 4 }}
          />
          <br />
          <Skeleton
            active
            paragraph={{ rows: 8 }}
          />
          <br />
          <Skeleton
            active
            paragraph={{ rows: 4 }}
          />
          <br />
          <Skeleton
            active
            paragraph={{ rows: 4 }}
          />
        </>
      ) : (
        <div className="claim-history-detail-form-modal flex-lg-wrap justify-content-start mr-3">
          <div className="row">
            <div className="col-lg-24">
              <Button type="primary" className="print-button" style={{ float: 'right' }} onClick={print} icon={<PrinterOutlined />}>
                Print
              </Button>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 col-md-12 col-print-6">
              <table className="test" style={{ textAlign: "left" }}>
                <tbody>
                  <tr>
                    <th className="bold">Claim No:</th>
                    <td>{claimMaster.RmiClaimNo}</td>
                  </tr>
                  <tr>
                    <th className="bold">Date Received:</th>
                    <td>{moment(claimMaster.RmiDateRecd).format('MM/DD/YYYY')}</td>
                  </tr>
                  <tr>
                    <th className="bold">Auth No:</th>
                    <td> {claimMaster.RmiAuthNo}</td>
                  </tr>
                  <tr>
                    <th className="bold">Provider Claim No:</th>
                    <td>{claimMaster.RmiProvClaim}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="col-lg-12 col-md-12 col-print-6">
              <table className="test" style={{ textAlign: "left" }}>
                <tbody>
                  <tr>
                    <th className="bold">Status:</th>
                    <td>{claimMaster.RmiStatus}</td>
                  </tr>
                  <tr>
                    <th className="bold">Date Paid:</th>
                    <td>{moment(claimMaster.RmiDatePaid).format('MM/DD/YYYY')}</td>
                  </tr>
                  <tr>
                    <th className="bold">Check No:</th>
                    <td>{claimMaster.RmiCheckNo}</td>
                  </tr>
                  <tr>
                    <th className="bold">Place of Service:</th>
                    <td>{claimMaster.RmiPlaceSvc}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <Divider className="claim-history-detail-form-modal-divider" />

          <div className="row">
            <div className="col-lg-12 col-md-12 col-print-6">
              <table className="test" style={{ textAlign: "left" }}>
                <tbody>
                  <tr>
                    <th className="bold">Member:</th>
                    <td>{claimMaster.RmiMembName}</td>
                  </tr>
                  <tr>
                    <th className="bold">Gender:</th>
                    <td>{claimMaster.RmiGender}</td>
                  </tr>
                  <tr>
                    <th className="bold">HP Name:</th>
                    <td>{claimMaster.RmiHpName}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="col-lg-12 col-md-12 col-print-6">
              <table className="test" style={{ textAlign: "left" }}>
                <tbody>
                  <tr>
                    <th className="bold">Member ID:</th>
                    <td>{claimMaster.RmiMembId}</td>
                  </tr>
                  <tr>
                    <th className="bold">DOB:</th>
                    <td>{formatDate(claimMaster.RmiBirth, 'MM/DD/YYYY')}</td>
                  </tr>
                  <tr>
                    <th className="bold">Opt:</th>
                    <td>{claimMaster.RmiOpt}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <Divider className="claim-history-detail-form-modal-divider" />

          <div className="row">
            <div className="col-lg-12 col-md-12 col-print-6">
              <table className="test" style={{ textAlign: "left" }}>
                <tbody>
                  <tr>
                    <th className="bold">Provider Name</th>
                    <td>{claimMaster.RmiRevFullName}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="col-lg-12 col-md-12 col-print-6">
              <table className="test" style={{ textAlign: "left" }}>
                <tbody>
                  <tr>
                    <th className="bold">Provider ID:</th>
                    <td>{claimMaster.RmiProvId}</td>
                  </tr>
                  <tr>
                    <th className="bold">Specialty:</th>
                    <td>{claimMaster.RmiSpec}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <Divider className="claim-history-detail-form-modal-divider" />

          <div className="row">
            <div className="col-lg-12 col-md-12 col-print-6">
              <table className="test" style={{ textAlign: "left" }}>
                <tbody>
                  <tr>
                    <th className="bold">Resubmission Code:</th>
                    <td>{claimMaster.RmiFrequencyCode}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div className="col-lg-12 col-md-12 col-print-6">
              <table className="test" style={{ textAlign: "left" }}>
                <tbody>
                  <tr>
                    <th className="bold">Original Refer No.:</th>
                    <td>{claimMaster.RmiMiscOriginalRefNo}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <Divider className="claim-history-detail-form-modal-divider" />

          <Title level={5}>
            Diagnosis
          </Title>

          <div className="row">
            <div className="col-lg-24">
              <Table
                columns={paymentDetailColumns}
                dataSource={claimDiags}
                pagination={false}
              />
            </div>
          </div>

          <Divider className="claim-history-detail-form-modal-divider" />

          <div className="row">
            <div className="col-lg-24">
              <Title level={5}>
                Details
              </Title>
              <Table
                className="claim-detail-table"
                columns={amountBilledColumns}
                dataSource={claimDetails}
                pagination={false}
                summary={claimDetails => {
                  let billTotal = 0;
                  let copayTotal = 0;
                  let dedTotal = 0;
                  let netPaidTotal = 0;

                  claimDetails.forEach((record: any) => {
                    billTotal += record.RmiBilled;
                    copayTotal += record.RmiCopay;
                    dedTotal += record.RmiDeductible;
                    netPaidTotal += record.RmiNet;
                  });

                  return (
                    <>
                      <Table.Summary.Row>
                        <Table.Summary.Cell index={0}></Table.Summary.Cell>
                        <Table.Summary.Cell index={1}></Table.Summary.Cell>
                        <Table.Summary.Cell index={2}></Table.Summary.Cell>
                        <Table.Summary.Cell index={3}></Table.Summary.Cell>
                        <Table.Summary.Cell index={4}>Totals</Table.Summary.Cell>
                        <Table.Summary.Cell index={5}>Bill Total: ${billTotal.toFixed(2)}</Table.Summary.Cell>
                        <Table.Summary.Cell index={6}>Copay Total: ${copayTotal.toFixed(2)}</Table.Summary.Cell>
                        <Table.Summary.Cell index={7}>Ded Total: ${dedTotal.toFixed(2)}</Table.Summary.Cell>
                        <Table.Summary.Cell index={8}></Table.Summary.Cell>
                        <Table.Summary.Cell index={9}>Net Total: ${netPaidTotal.toFixed(2)}</Table.Summary.Cell>
                      </Table.Summary.Row>
                    </>
                  );
                }}
              />
            </div>
          </div>

          <Divider className="claim-history-detail-form-modal-divider" />

          <Title level={5}>
            Attachments
          </Title>
          <ul>
            {props.attachmentList.map((attachment: any, key: number) => { return <li key={key}> {attachment}</li> })}
          </ul>
        </div>
      )}
    </Modal>
  );
};

export default ClaimHistoryDetailModal;